module.exports = __webpack_public_path__ + "static/media/ic-meal.cdd5d9cc.svg";